import {
  AccountCircle,
  DashboardOutlined,
  DirectionsBoatOutlined,
  GroupOutlined,
  Inventory2Outlined,
  LocalShippingOutlined,
  TurnedInNotOutlined,
} from "@mui/icons-material";

const menuItems = [
  {
    heading: "General",
    items: [
      {
        name: "Anasayfa",
        icon: DashboardOutlined,
        link: "/home",
      },
      {
        name: "Sipariş",
        icon: LocalShippingOutlined,
        link: "/orders",
        permission: "order.view_order",
      },
      {
        name: "Konteyner",
        icon: DirectionsBoatOutlined,
        link: "/containers",
        permission: "container.view_container",
      },
      {
        name: "Referans",
        icon: TurnedInNotOutlined,
        link: "/references",
        permission: "product.view_customerproductreference",
      },
      {
        name: "Ürün",
        icon: Inventory2Outlined,
        link: "/products",
        permission: "product.view_product",
      },
      {
        name: "Müşteri",
        icon: GroupOutlined,
        link: "/customers",
      },
      ,
      {
        name: "Kullanıcı",
        icon: AccountCircle,
        link: "/users",
        permission: "user.view_appuser",
      },
    ],
  },
];

export default menuItems;
